module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Add',
        happyBday: 'Happy B-Day',
        chooseGift: 'Choose Your Birthday Gift'
    };
    return resources[label];
};
